import { NotifyType } from "UidispatcherApiModule";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-ignore
const UidispatcherApiModule = await import("uidispatcher_api/UidispatcherApiModule");
export const notify: NotifyType = UidispatcherApiModule.notify;
